console.log('DEBUG: gender-filter.js wurde geladen');
document.addEventListener('DOMContentLoaded', function() {
  const genderFilterEl = document.querySelector('.gender-filter');
  if (!genderFilterEl) return;

  const buttons = genderFilterEl.querySelectorAll('.gender-filter__btn');

  function applyGenderFilter(gender) {
    // Auswahl speichern
    genderFilterEl.setAttribute('data-selected-gender', gender);

    // Aktiven Button hervorheben
    buttons.forEach(b => b.classList.remove('is-active'));
    const activeBtn = [...buttons].find(
      b => b.getAttribute('data-gender-choice') === gender
    );
    if (activeBtn) {
      activeBtn.classList.add('is-active');
    }

    // Produkte filtern
const allCollectionItems = document.querySelectorAll(
  '[data-collection-gender]'
);

allCollectionItems.forEach((colItem) => {
  const colGender =
    colItem.getAttribute('data-collection-gender') || 'all';

  const isGeneralCollection =
    colGender === 'all' ||
      colGender === 'unisex' ||
    colGender === 'all-bags' ||
    colGender === 'unisex-bags';

  const shouldShow =
    gender === 'all'
      ? isGeneralCollection
      : colGender === gender ||
        colGender === 'all-bags' ||
        colGender === 'unisex-bags';

  colItem.classList.toggle('gender-hidden', !shouldShow);
});



  }

  // Klick-Events verbinden
  buttons.forEach((btn) => {
    btn.addEventListener('click', () => {
      const chosen = btn.getAttribute('data-gender-choice');
      applyGenderFilter(chosen);
    });
  });

  // Beim Laden anwenden
  applyGenderFilter(genderFilterEl.getAttribute('data-selected-gender') || 'all');
});
